module.exports = __webpack_public_path__ + "static/img/irole.410ef01.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/wxsjglm/irole.png
// module id = nuDF
// module chunks = 7